import { Separator } from '../../../components/ui/separator.jsx';
import CallAggregatedReports from '../CallAggregatedReports.jsx';
import Calls from '../Calls.jsx';
import { TabsContent } from '@/components/ui/tabs.jsx';

const CallsTab = ({community}) => {
    return (
        <TabsContent value="calls">
            <CallAggregatedReports community={community} timezone={community.time_zone} />
            <Separator className="my-8" />
            <Calls communityId={community.id} timezone={community.time_zone}/>
        </TabsContent>
    );
};

export default CallsTab;